$.fn.datepicker.dates['fr'] = {
  days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
  daysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
  daysMin: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
  months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  monthsShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
  today: "Aujourd'hui",
  clear: "Effacer",
  format: "dd/mm/yyyy",
  titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
  weekStart: 0
};

$.fn.datepicker.dates['en'] = {
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  daysMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  today: "Today",
  clear: "Clear",
  format: "mm/dd/yyyy",
  titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
  weekStart: 0
};

//- Materialize Init
$('select').material_select();

//- Dropdowns
$('.dropdown-button').dropdown();

// Modals
$('.modal').modal();

// Mobile Filters menu
$('#mobile_modal--filters').modal({
  inDuration: 300,
  outDuration: 200, // Transition out duration
  startingTop: 0,
  endingTop: 0
});

// Work Btns Modal
$('#job-modal').modal();
let workBtns = $('.std_gi--container-body .collapsible-body button');
workBtns.each(function () {
  let btn = this;
  btn.onclick = function () {
    $('#job-modal').modal('open');
  }
});

//- STD single Collapsable
$('.std_single--collaps').collapsible();
$('.std_single--beds-item').matchHeight({
  byRow: false
});
//$('.std_card--details .std_card--desc').matchHeight();
$('.about_activity--slider_inner .std_activity--preview').matchHeight();
$('.chalets_list--inner .std_card--fullwidth').matchHeight();
$('.std_activity--card .history-card').matchHeight();
//$('.home_chalet--slider_inner .std_card--details').matchHeight();
$('.activity-container.std_card--fullwidth .std_card--details').matchHeight({
  'byRow': false
});
// STD GI Collapsable
$('.std_gi--collaps').collapsible();

// Misc date select
$('input.form-date').datepicker({
  maxViewMode: 0,
  format: 'yyyy-mm-dd',
  startDate: new Date(),
  language: locale,
  multidate: false 
}).on('changeDate', function (e) {
  $(e.target).datepicker('hide');
});


// Dev Only
//$('#mobile_modal--filters').modal('open');


// Mobile Filters Modal
let mobFiltersBtnO = $('.mob_filters--modal-o');
let mobFiltersBtnC = $('.mob_filters--modal-c');
if (mobFiltersBtnO.length) {
  mobFiltersBtnO.each(function () {
    let btn = this;
    btn.onclick = function () {
      $('#mobile_modal--filters').modal('open');
    };
  });
}
if (mobFiltersBtnC.length) {
  mobFiltersBtnC.each(function () {
    let btn = this;
    btn.onclick = function () {
      $('#mobile_modal--filters').modal('close');
      setTimeout(function () {
        $('.close-nav').trigger('click');
      }, 1)
    };
  });
}

//- Main Footer
let mainFooter = $('.main_footer');
let footerPars = mainFooter.find('.mob_par--btn');

$(".questions-cond .options-cond").change(function(e) {
  var value = $(e.target).val();
  var $questions = $(e.target).closest(".questions-cond").find('.fields-cond');
  var visible = value == 'y';
  $questions.css('display', visible ? 'block' : 'none');
  $questions.find('.required-field').prop('required',visible);
});

function updateFooter() {
  if (footerPars.length) {
    footerPars.each(function () {
      let par = this;
      par.onclick = function (e) {
        e.preventDefault();
        let p = e.currentTarget;
        if (p.nodeName.toUpperCase() === 'A') {
          // Open Footer nav
          let nextsChilds = $(p).nextUntil('.main_footer--sub-title-1');
          nextsChilds.each(function () {
            let subLink = this;
            if (subLink.style.display === '') {
              p.classList.add('mob_par--btn-opened');
              subLink.style.display = 'block';
              setTimeout(function () {
                subLink.style.opacity = 1;
              }, 10);
            } else {
              p.classList.remove('mob_par--btn-opened');
              subLink.style.opacity = 0;
              setTimeout(function () {
                subLink.style.display = '';
              }, 300);
            }
          });
        }
      };
    });
  }
}

if ($(window).outerWidth() < 808) {
  updateFooter();
}
$('.home_events--slider_inner').owlCarousel({
  loop: false,
  nav: false,
  margin: 18,
  smartSpeed: 500,
  responsive: {
    0: {
      items: 1,
      margin: 6
    },
    750: {
      items: 2
    },
    1032: {
      items: 3
    },
    1290: {
      items: 3
    }
  }
});

// Fix resize probs
window.addEventListener('resize', function () {
  if (768 < window.innerWidth) {
    let parLinks = $(mainFooter).find('.main_footer--sub-title-1');
    let subLinks = $(mainFooter).find('.main_footer--sub-title-2');
    parLinks.each(function () {
      this.style.display = '';
      this.style.opacity = '';
    });
    subLinks.each(function () {
      this.style.display = '';
      this.style.opacity = '';
    });
  }
  if ($(window).outerWidth() < 808) {
    updateFooter();
  }

});


function GetSelectedArray(startDate, endDate) {
  let dateArray = [];
  let currentDate = moment(startDate.split('/').reverse().join('/'));
  let stopDate = moment(endDate.split('/').reverse().join('/'));
  while (currentDate <= stopDate) {
    dateArray.push(moment(currentDate).format('DD/MM/YYYY'))
    currentDate = moment(currentDate).add(1, 'days');
  }
  return dateArray;
}

function checkForDisabled(array1, array2) {
  let test = false;
  for (let i = 0; i < array1.length; i++) {
    if (array2.indexOf(array1[i]) !== -1) {
      test = true;
      break;
    }
  }
  return test;
}


//- Std Chalet res btn
let conBtn = $('.activity_single--contact-mob-btn')[0];

function conModalFunc() {
  if (conBtn) {
    if (window.innerWidth <= 808) {
      $('.activity_single--contact').addClass('as_modal').addClass('modal');
      $('.activity_single--contact').modal({
        inDuration: 300, // Transition in duration
        outDuration: 200, // Transition out duration
        startingTop: '4%', // Starting top style attribute
        endingTop: '10%', // Ending top style attribute
      });
      $('.activity_single--contact').modal('open');
    } else {
      $('.activity_single--contact').removeClass('as_modal').removeClass('modale');
      $('.activity_single--contact').trigger('destroy.owl.carousel');
    }
  }
}

if (conBtn) {
  conBtn.onclick = function () {
    conModalFunc();
  };
}

//- STD Wiz
let wizs = $('.std_wiz--container');
wizs.each(function () {
  // fix Table on mobile
  if (window.innerWidth < 808) {
    let tables = $(this).find('table');
    tables.each(function () {
      let t = this;
      let p = t.parentNode;
      let newT = document.createElement('DIV');
      let newTC = t.cloneNode(true);
      newT.appendChild(newTC);
      newT.style.overflowX = 'auto';
      p.insertBefore(newT, t);
      p.removeChild(t);
    });
  }
});


if (/Edge/.test(navigator.userAgent)) {
  $('body').css('overflow-x', 'hidden')
}

let daysOfWeek = [];
let monthNames = [];
daysOfWeek['fr'] = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
daysOfWeek['en'] = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
monthNames['fr'] = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
monthNames['en'] = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function zeroPad(num, places) {
  var zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join("0") + num;
}


function transformDate(da) {
  let year = da.getFullYear();
  let month = zeroPad(da.getMonth() + 1, 2);
  let day = zeroPad(da.getDate(), 2);
  return day + '/' + month + '/' + year;
}

var paramsToQuery = function paramsToQuery(params, optParams) {
  var q = '';
  var qParams = {};

  for (var k in params) {
    qParams[k] = params[k];
  }

  if (optParams) for (var l in optParams) {
    qParams[l] = optParams[l];
  }
  var keys = Object.keys(qParams);

  if (keys.length > 0) {
    var args = [];

    for (var i = 0; i < keys.length; i++) {
      if (qParams[keys[i]]) {
        args.push(keys[i] + '=' + qParams[keys[i]]);
      }
    }

    if (args.length > 0) {
      q = "?" + args.join('&');
    }
  }

  return q;
};